export default {
  brand: {
    name: "Arman Delivery",
    full: "Arman Delivery & Taxi",
    sub: "& Տաքսի · Երևան",
  },
  language: {
    label: "Լեզու",
    en: "Անգլերեն",
    hy: "Հայերեն",
    ru: "Ռուսերեն",
  },
  nav: {
    home: "Գլխավոր",
    services: "Ծառայություններ",
    fleet: "Ավտոպարկ",
    how: "Ինչպես վարձակալել",
    pricing: "Գներ",
    service: "Սպասարկման կենտրոն",
    faq: "Հաճախ տրվող հարցեր",
    contact: "Կապ",
    callNow: "Զանգահարել",
    whatsapp: "Գրել WhatsApp-ով",
  },
  wa: {
    nav: "Ողջույն Arman Delivery, ցանկանում եմ տրանսպորտ վարձակալել Երևանում",
    hero: "Ողջույն Arman Delivery, ցանկանում եմ մոտոցիկլետ վարձակալել Երևանում",
    fleet: "Ողջույն Arman Delivery, ցանկանում եմ վարձակալել {{vehicle}}",
    pricing: "Ողջույն Arman Delivery, ինձ հետաքրքրում է {{plan}} փաթեթը",
    how: "Ողջույն Arman Delivery, ցանկանում եմ սկսել վարձակալության գործընթացը",
    service: "Ողջույն Arman, ինձ պետք է սպասարկում իմ տրանսպորտի համար",
    contact: "Ողջույն Arman Delivery, ցանկանում եմ տրանսպորտ վարձակալել",
    footer: "Ողջույն Arman Delivery, ունեմ հարց",
    float: "Ողջույն Arman Delivery, ինձ պետք է տեղեկություն տրանսպորտի վարձույթի մասին",
  },
  hero: {
    badge: "Հայաստան · Երևան · Սկզբից ի վեր",
    title1: "Վարձակալի՛ր մոտոցիկլետ,",
    title2: "վարի՛ր ու վաստակի՛ր",
    title3: "ամեն օր",
    paragraph:
      "<b>{{brand}}</b> ընկերությունն առաջարկում է Երևանի առաքիչների համար մոտոցիկլետների, սկուտերների և մեքենաների ամենամատչելի շաբաթական վարձույթը։ Սկսի՛ր վաստակել սննդի և առաքման հարթակներում — մենք հոգում ենք տրանսպորտի, սպասարկման և պահեստամասերի մասին։",
    ctaWhatsapp: "Գրի՛ր WhatsApp-ով",
    ctaFleet: "Տեսնել մեր ավտոպարկը",
  },
  stats: {
    riders: "Սպասարկված վարորդ",
    vehicles: "Ակտիվ տրանսպորտ",
    support: "Աջակցություն և սպասարկում",
    rates: "Շաբաթական գներ Երևանում",
  },
  marquee: {
    bike: "Շաբաթական մոտո վարձույթ",
    scooter: "Սկուտերի վարձույթ",
    car: "Մեքենայի վարձույթ",
    service: "Սպասարկման կենտրոն",
    parts: "Բոլոր պահեստամասերը",
    whatsapp: "WhatsApp աջակցություն 24/7",
    location: "Ռուբինյանց փողոց 28/1, Զեյթուն",
  },
  services: {
    eyebrow: "Ինչ ենք առաջարկում",
    title1: "Ամեն ինչ մեկ տեղում՝",
    title2: "Հայաստանի առաքիչների համար",
    subtitle:
      "Վարձույթից մինչև սպասարկում ու պահեստամասեր — Arman Delivery-ը հոգում է վարորդի ամբողջ ճանապարհը։",
    learnMore: "Իմանալ ավելին",
    bike: {
      title: "Մոտոցիկլետի վարձույթ",
      description:
        "Մատչելի շաբաթական մոտոցիկլետի վարձույթ սննդի առաքման, կուրիեր աշխատանքի և անձնական երթևեկության համար Երևանում։",
    },
    scooter: {
      title: "Սկուտերի վարձույթ",
      description:
        "Վառելիքախնայող ավտոմատ սկուտերներ, որոնք իդեալական են քաղաքային առաքման երթուղիների համար՝ քաղաքի ամենացածր շաբաթական գնով։",
    },
    car: {
      title: "Մեքենայի վարձույթ",
      description:
        "Հուսալի սեդաններ և հեչբեքներ տաքսու վարորդների և հեռահար առաքման գործընկերների համար։",
    },
    service: {
      title: "Սպասարկման կենտրոն",
      description:
        "Տեղում ամբողջական սպասարկում, յուղի փոխում, կարգավորում և վերանորոգում մեր վարձակալած ողջ տրանսպորտի համար։",
    },
    parts: {
      title: "Պահեստամասեր",
      description:
        "Բնօրինակ և OEM պահեստամասեր մեր պահեստում, որպեսզի ձեր տրանսպորտը երկար չմնա առանց աշխատանքի։",
    },
    roadside: {
      title: "Ճանապարհային աջակցություն",
      description:
        "Օգնություն Երևանում անսարքության դեպքում։ Մեկ զանգ կամ մեկ WhatsApp հաղորդագրություն, և մենք գալիս ենք ձեզ մոտ։",
    },
  },
  fleet: {
    eyebrow: "Մեր ավտոպարկը",
    title1: "Ընտրի՛ր քո տրանսպորտը՝",
    title2: "Երևանի ստանդարտով",
    subtitle:
      "Ստորև բոլոր շաբաթական գները համապատասխանում են Երևանում գործող շուկայական ստանդարտին։ Ամբողջությամբ ապահովագրված, ճանապարհային փորձարկում անցած և սպասարկվող մեր սեփական արհեստանոցի կողմից։",
    weeklyRate: "Շաբաթական գին",
    lease: "Վարձակալել",
    perWeek: "{{price}} AMD / շաբաթ",
    fuelPetrol: "Բենզին · {{value}} կմ/լ",
    seats: "{{count}} տեղանոց",
    categories: {
      all: "Բոլորը",
      bikes: "Մոտոցիկլետներ",
      scooters: "Սկուտերներ",
      cars: "Մեքենաներ",
    },
    badges: {
      foodDelivery: "Լավագույնը սննդի առաքման համար",
      mileage: "Ամենախնայող մոտոցիկլետը",
      comfort: "Հարմարավետ առաքում",
      courier: "Հզոր կուրիերային մոտոցիկլետ",
      taxi: "Լավագույնը տաքսու վարորդների համար",
      family: "Ընտանեկան տաքսի",
      premium: "Պրեմիում առաքման մոտոցիկլետ",
    },
  },
  how: {
    eyebrow: "Ինչպես վարձակալել",
    title: "Ելի՛ր ճանապարհ 4 հեշտ քայլով",
    subtitle: "Պարզ, արագ և թափանցիկ։ Սկսի՛ր առաքման կարիերան Arman-ի հետ այսօր։",
    cta: "Սկսի՛ր վարձույթը այսօր",
    choose: {
      title: "Ընտրի՛ր տրանսպորտը",
      description:
        "Դիտի՛ր մեր մոտոցիկլետների, սկուտերների և մեքենաների ավտոպարկը և ընտրի՛ր մոդելը, որը համապատասխանում է քո աշխատանքին և բյուջեին։",
    },
    docs: {
      title: "Ներկայացրու՛ փաստաթղթերը",
      description:
        "Բերի՛ր անձնագիրդ, վարորդական իրավունքդ և մեկ լուսանկար։ Տեղում կկազմենք պարզ շաբաթական վարձակալության պայմանագիր։",
    },
    pay: {
      title: "Վճարի՛ր շաբաթական",
      description:
        "Վճարի՛ր միայն այն շաբաթվա համար, երբ վարում ես։ Ոչ երկար պայմանագրեր, և գները համապատասխանում են Երևանի շուկայի ստանդարտին։",
    },
    ride: {
      title: "Վարի՛ր և վաստակի՛ր",
      description:
        "Վերցրու՛ բանալիները և սկսի՛ր վաստակել Հայաստանի ցանկացած սննդի կամ կուրիեր հարթակում նույն օրը։",
    },
  },
  pricing: {
    eyebrow: "Շաբաթական գներ",
    title1: "Շաբաթական վարձավճար՝",
    title2: "Երևանի ստանդարտ գներով",
    subtitle:
      "Թափանցիկ գներ առանց թաքնված վճարների։ Դու վճարում ես միայն այն շաբաթվա համար, երբ վարում ես։",
    note: "Գները կարող են տարբերվել՝ կախված մեքենայի մոդելից։ Գործում է վերադարձվող ավանդ։ Ճշգրիտ գնի համար կապվի՛ր մեզ հետ WhatsApp-ով։",
    plans: {
      bike: {
        name: "Մոտոցիկլետ շաբաթական",
        tag: "Ամենացած գին",
        unit: "AMD / շաբաթ",
        cta: "Վարձակալել մոտոցիկլետ",
        f1: "Իդեալական է սննդի և առաքման աշխատանքի համար",
        f2: "Շաբաթական վճարում, առանց երկար պայմանագրի",
        f3: "Անվճար հիմնական սպասարկում",
        f4: "Ճանապարհային աջակցությունը ներառված է",
        f5: "Սաղավարտ և առաքման արկղ՝ լրացուցիչ",
      },
      scooter: {
        name: "Սկուտեր շաբաթական",
        tag: "Ամենապահանջված",
        unit: "AMD / շաբաթ",
        cta: "Վարձակալել սկուտեր",
        f1: "Ավտոմատ է և հեշտ վարելի",
        f2: "Կատարյալ է սկսնակ վարորդների համար",
        f3: "Շաբաթական սպասարկման ստուգում",
        f4: "Առաջնահերթ մուտք դեպի պահեստամասեր",
        f5: "Առաքման արկղը ներառված է",
      },
      car: {
        name: "Մեքենա շաբաթական",
        tag: "Երևանի ստանդարտ",
        unit: "AMD / շաբաթ",
        cta: "Վարձակալել մեքենա",
        f1: "Հարմար է տաքսու և հեռահար առաքման համար",
        f2: "Ամբողջական ապահովագրությունը ներառված է",
        f3: "Անվճար յուղի փոխում ամեն ամիս",
        f4: "4-5 տեղանոց տարբերակներ",
        f5: "Վառելիքախնայող մոդելներ",
      },
    },
  },
  service: {
    eyebrow: "Սպասարկման կենտրոն և պահեստամասեր",
    title1: "Ամեն ինչ մեկ տեղում։",
    title2: "Վարձույթից մինչև վերջին պտուտակը։",
    subtitle:
      "Մեր վարձակալած ողջ տրանսպորտը ամբողջությամբ սպասարկվում է մեր սեփական սպասարկման կենտրոնում՝ Զեյթունի Ռուբինյանց փողոցում։ Անսարքություն, փոքր վերանորոգում կամ պահեստամաս — ամեն ինչ անում ենք արագ, ազնիվ և արդար գնով։",
    turnaround: "2 ժ",
    turnaroundLabel: "Սպասարկման միջին տևողություն",
    rating: "Գնահատել են 300+ վարորդ",
    bookBtn: "Ամրագրել սպասարկում",
    callBtn: "Զանգահարել արհեստանոց",
    workshop: {
      title: "Ամբողջական սպասարկման արհեստանոց",
      description: "Սերտիֆիկացված մեխանիկներ մոտոցիկլետների, սկուտերների և մեքենաների համար՝ մեկ հարկի տակ։",
    },
    parts: {
      title: "Բնօրինակ պահեստամասեր",
      description: "OEM և բնօրինակ մասերի ամբողջական պահեստ, որպեսզի վերանորոգումը օրեր չտևի։",
    },
    maintenance: {
      title: "Անվճար հիմնական սպասարկում",
      description: "Յուրաքանչյուր վարձակալված տրանսպորտ ստանում է անվճար յուղի փոխում և անվտանգության ստուգում։",
    },
    guarantee: {
      title: "Որակի երաշխիք",
      description: "30-օրյա սպասարկման երաշխիք մեր արհեստանոցում կատարված յուրաքանչյուր վերանորոգման համար։",
    },
  },
  testimonials: {
    eyebrow: "Վարորդների պատմություններ",
    title1: "Վստահում են Երևանի",
    title2: "առաքման համայնքը",
    davit: {
      role: "Glovo առաքիչ",
      quote:
        "Անցյալ ամառ սկսեցի Arman-ի հետ Splendor մոտոցիկլետով։ Շաբաթական գինը, անկեղծ ասած, ամենացածն է Երևանում, և երբ սպասարկում է պետք լինում, նույն օրն են վերանորոգում։",
    },
    narek: {
      role: "Yandex Delivery",
      quote:
        "Նրանց սկուտերը փրկեց ինձ հասարակական տրանսպորտի քաոսից։ Վառելիքը էժան է, իսկ սպասարկումը՝ անվճար առաջին ամիս։ Խորհուրդ եմ տալիս բոլոր առաքիչներին։",
    },
    aram: {
      role: "Տաքսու վարորդ",
      quote:
        "Arman-ից շաբաթական մեքենա եմ վարձակալում տաքսու աշխատանքի համար։ Թափանցիկ գին, առանց խաղերի և անակնկալների։ Նրանց պահեստամասերի պաշարը հիանալի է։",
    },
  },
  faq: {
    eyebrow: "Հաճախ տրվող հարցեր",
    title: "Ամեն ինչ, ինչ ուզում ես իմանալ",
    documents: {
      q: "Ի՞նչ փաստաթղթեր են պետք մոտոցիկլետ կամ մեքենա վարձակալելու համար։",
      a: "Պետք է վավեր հայկական կամ միջազգային վարորդական իրավունք, անձնագիր կամ ID քարտ, մեկ վերջին լուսանկար և վերադարձվող գրավ։ Այսքանը, և տեղում կկազմենք պարզ շաբաթական պայմանագիր։",
    },
    weekly: {
      q: "Որքա՞ն է շաբաթական վարձավճարը Երևանում մոտոցիկլետի համար։",
      a: "Շաբաթական մոտո վարձույթը սկսվում է 30,000 AMD-ից, սկուտերները՝ 17,000 AMD-ից, մեքենաները՝ 55,000 AMD-ից։ Գները հետևում են Երևանի շուկայի ստանդարտին և կարող են փոքր-ինչ տարբերվել մոդելից։",
    },
    support: {
      q: "Տրամադրու՞մ եք սպասարկում և պահեստամասեր վարձակալված տրանսպորտի համար։",
      a: "Այո։ Մեր վարձակալած յուրաքանչյուր տրանսպորտ ամբողջությամբ սպասարկվում է Ռուբինյանց փողոցի մեր սեփական սպասարկման կենտրոնում։ Հիմնական սպասարկումը անվճար է վարձակալության հաճախորդների համար, և բնօրինակ պահեստամասերը միշտ առկա են։",
    },
    delivery: {
      q: "Կարո՞ղ եմ տրանսպորտը օգտագործել Glovo, Yandex կամ Wolt առաքման համար։",
      a: "Անշուշտ։ Մեր ավտոպարկը ստեղծված է առաքման աշխատանքի համար, և մեր վարորդների մեծ մասը իր տրանսպորտն օգտագործում է Glovo, Yandex, Wolt և Երևանի այլ կուրիեր հարթակներում։",
    },
    breakdown: {
      q: "Ի՞նչ անել, եթե տրանսպորտը փչանա աշխատանքի ընթացքում։",
      a: "Զանգահարի՛ր կամ գրի՛ր մեզ WhatsApp-ով։ Առաջարկում ենք ճանապարհային աջակցություն ամբողջ Երևանում և հնարավորինս արագ կվերանորոգենք կամ կփոխարինենք անսարք տրանսպորտը, որ դու շարունակես վաստակել։",
    },
    sell: {
      q: "Պահեստամասեր վաճառու՞մ եք նաև ոչ վարձակալ հաճախորդներին։",
      a: "Այո։ Ցանկացած մարդ կարող է պահեստամասեր գնել մեր արհեստանոցից, ոչ միայն վարձակալության հաճախորդները։ Արի՛ խանութ կամ գրի՛ր մեզ անհրաժեշտ մասի համար՝ արագ գին ստանալու համար։",
    },
  },
  contact: {
    eyebrow: "Կապ մեզ հետ",
    title1: "Եկեք այսօր",
    title2: "ճանապարհ դնենք ձեզ",
    subtitle: "Արի՛ մեր արհեստանոց կամ գրի՛ր WhatsApp-ով — սովորաբար պատասխանում ենք 5 րոպեի ընթացքում։",
    whatsappTitle: "Գրի՛ր մեզ WhatsApp-ով",
    whatsappSub: "Ամենաարագ պատասխան · 24/7",
    callTitle: "Զանգահարի՛ր ուղղակիորեն",
    callHours: "Երկ-Կիր · 9:00 - 21:00",
    visitTitle: "Այցելի՛ր մեր արհեստանոցը",
    addressLine: "Ռուբինյանց փողոց 28/1, Զեյթուն",
    addressCity: "Երևան 0069, Հայաստան",
    form: {
      title: "Ուղարկի՛ր վարձակալության հարցում",
      subtitle: "Պատմի՛ր մեզ, ինչ է պետք, և մենք կպատասխանենք WhatsApp-ով կամ հեռախոսով։",
      name: "Անուն Ազգանուն *",
      namePlaceholder: "Ձեր անունը",
      phone: "Հեռախոս / WhatsApp *",
      email: "Էլ. փոստ",
      vehicleLabel: "Հետաքրքրող տրանսպորտ *",
      vehiclePlaceholder: "Ընտրի՛ր տրանսպորտի տեսակը",
      optionBike: "Մոտոցիկլետի վարձույթ",
      optionScooter: "Սկուտերի վարձույթ",
      optionCar: "Մեքենայի վարձույթ",
      optionService: "Սպասարկում / վերանորոգում",
      optionParts: "Պահեստամասեր",
      optionHero: "Hero Splendor (նոր)",
      message: "Հաղորդագրություն",
      messagePlaceholder: "Պատմի՛ր, ինչ է պետք...",
      maxChars: "Առավելագույնը 500 նշան",
      submit: "Ուղարկել",
      sending: "Ուղարկվում է...",
      success: "Շնորհակալություն։ Ձեր հարցումն ուղարկվել է, և մենք շուտով կկապվենք Ձեզ հետ։",
      errorNetwork: "Ցանցային սխալ։ Խնդրում ենք փորձել կրկին կամ գրել մեզ WhatsApp-ով։",
      errorGeneric: "Չհաջողվեց ուղարկել ձեր հարցումը։ Խնդրում ենք փորձել կրկին կամ գրել մեզ WhatsApp-ով։",
    },
  },
  footer: {
    about:
      "Մոտոցիկլետների, սկուտերների և մեքենաների վարձույթի ամեն ինչ մեկ տեղում Երևանում, Հայաստան։ Այսօր ելի՛ր ճանապարհ քաղաքի ամենացածր շաբաթական գներով։",
    services: "Ծառայություններ",
    company: "Ընկերություն",
    contact: "Կապ",
    bike: "Մոտոցիկլետի վարձույթ",
    scooter: "Սկուտերի վարձույթ",
    car: "Մեքենայի վարձույթ",
    serviceCenter: "Սպասարկման կենտրոն",
    spare: "Պահեստամասեր",
    how: "Ինչպես վարձակալել",
    pricing: "Շաբաթական գներ",
    faq: "Հաճախ տրվող հարցեր",
    whatsappChat: "WhatsApp չատ",
    hours: "Երկ-Կիր · 9:00 - 21:00",
    rights: "© 2026 Arman Delivery & Taxi։ Բոլոր իրավունքները պաշտպանված են։",
    curated: "Ստեղծված SkyEdge Infotech LLC-ի կողմից",
  },
  whatsappFloat: "Զրուցի՛ր մեզ հետ",
};